import React from 'react';

const Settings: React.FC = () => {
  return <h1>Settings</h1>;
};

export default Settings;